import { Store } from './main';
import rest from '@/plugins/rest';

class BookingStore extends Store {
  data() {
    return {
      referralStep: null,
      referral: null,
      referralProcedure: null,
      step: { name: 'start', showStepper: false, title: '', subTitle: '' },
      apiUrls: {},
      appointmentAccessCode: null,
      appointmentProcedureId: null,
      scans: [],
      scanId: null,
      bodyParts: [],
      bodyPartId: null,
      scanRegions: [],
      scanRegionId: null,
      insurers: [],
      insurer: null,
      clinicId: null,
      clinic: null,
      clinics: [],
      slot: null,
      scheduleDialogOpen: false,
      patientForm: {
        submitted: false,
        data: {}
      },
      isUserWhitelisted: false,
      maintenanceMode: false
    };
  }
  setReferralStep(referralStep) {
    this.state.referralStep = referralStep;
  }
  setReferral(referral) {
    this.state.referral = referral;
  }
  setReferralProcedure(procedure) {
    this.state.referralProcedure = procedure;
  }
  setStep(step) {
    this.state.step = step;
  }
  setStepName(name) {
    this.state.step.name = name;
  }
  setShowStepper(showStepper) {
    this.state.step.showStepper = showStepper;
  }
  setStepTitle(title) {
    this.state.step.title = title;
  }
  setStepSubTitle(subTitle) {
    this.state.step.subTitle = subTitle;
  }
  setApiUrls(apiUrls) {
    this.state.apiUrls = apiUrls;
  }
  setAppointmentAccessCode(appointmentAccessCode) {
    this.state.appointmentAccessCode = appointmentAccessCode;
  }
  setAppointmentProcedureId(appointmentProcedureId) {
    this.state.appointmentProcedureId = appointmentProcedureId;
  }
  setScans(scans) {
    this.state.scans = scans;
  }
  setScanId(scanId) {
    this.state.scanId = scanId;
  }
  setBodyPartId(bodyPartId) {
    this.state.bodyPartId = bodyPartId;
  }
  setScanRegionId(scanRegionId) {
    this.state.scanRegionId = scanRegionId;
  }
  setBodyParts(bodyParts) {
    this.state.bodyParts = bodyParts;
  }
  setScanRegions(scanRegions) {
    this.state.scanRegions = scanRegions;
  }
  setInsurers(insurers) {
    this.state.insurers = insurers;
  }
  setInsurer(insurer) {
    this.state.insurer = insurer;
  }
  setClinics(clinics) {
    this.state.clinics = clinics;
  }
  setClinicId(clinicId) {
    this.state.clinicId = clinicId;
  }
  setClinic(clinic) {
    this.state.clinic = clinic;
  }
  setSlot(slot) {
    this.state.slot = slot;
  }
  setScheduleDialogOpen(open) {
    this.state.scheduleDialogOpen = open;
    if (open) {
      window.parent.postMessage(
        {
          name: 'routeChanged',
          path: 'dialog'
        }, '*');
    }
  }
  setPatientForm(obj) {
    this.state.patientForm = obj
  }
  setPatientFormSubmitted(submitted) {
    this.state.patientForm.submitted = submitted
  }
  setPatientFormData(data) {
    this.state.patientForm.data = data
  }
  setIsUserWhitelisted(isUserWhitelisted) {
    this.state.isUserWhitelisted = isUserWhitelisted;
  }
  setMaintenanceMode(maintenanceMode) {
    this.state.maintenanceMode = maintenanceMode
  }
  clearStore() {
    // # DO NOT CLEAR APIS
    this.setReferralStep(null);
    this.setReferral(null);
    this.setReferralProcedure(null);
    this.setAppointmentAccessCode(null);
    this.setAppointmentProcedureId(null);
    this.setScans([]);
    this.setScanId(null);
    this.setBodyParts([]);
    this.setBodyPartId(null);
    this.setScanRegions([]);
    this.setInsurer(null);
    this.setInsurers([]);
    this.setClinicId(null);
    this.setClinic(null);
    this.setClinics([]);
    this.setSlot(null);
    this.setPatientForm({ submitted: false, data: {}});
    this.setStep({ name: 'start', showStepper: false, title: '', subTitle: '' });
  }
  clearSelectionsOnProcedure() {
    // # DO NOT CLEAR APIS
    this.setScanId(null);
    this.setBodyPartId(null);
    this.setInsurer(null);
    this.setScanRegionId(null);
    this.setClinicId(null);
    this.setClinic(null);
    this.setSlot(null);
    this.setScheduleDialogOpen(false);
    this.setPatientFormSubmitted(false);
  }
  clearSelectionsOnInsurer() {
    // # DO NOT CLEAR APIS
    this.setInsurer(null);
    this.setScanRegionId(null);
    this.setClinicId(null);
    this.setClinic(null);
    this.setSlot(null);
    this.setScheduleDialogOpen(false);
    this.setPatientFormSubmitted(false);
  }
  clearSelectionsOnClinic() {
    // # DO NOT CLEAR APIS
    this.setScanRegionId(null);
    this.setClinicId(null);
    this.setClinic(null);
    this.setSlot(null);
    this.setScheduleDialogOpen(false);
    this.setPatientFormSubmitted(false);
  }
  async getApiUrls(appointmentAccessCode, scanId) {
    const response = await rest
      .get(
        '',
        appointmentAccessCode ? { a: appointmentAccessCode, scanIds: [scanId], erl: true } : {},
      )
      const isUnderMaintenance = response.response.isUnderMaintenance
      this.setMaintenanceMode(isUnderMaintenance)
      if (this.state.maintenanceMode) {
        this.setStep({})
      }
      this.setApiUrls(response.response.urls);
      return response.status;
  }

  checkMaintenanceMode() {
    return new Promise((resolve) => {
      rest
        .get(this.state.apiUrls.checkMaintenanceModeUrl, {})
        .then(resp => resolve(resp.response.isUnderMaintenance))
        .catch(() => resolve(false))
    })
  }
}

export const bookingStore = new BookingStore();
